import { useTranslation } from 'react-i18next';
import type { InviteBasicResponse } from '../api/invites';

interface InviteEntryProps {
  invite: InviteBasicResponse;
  onAccept: (inviteId: string) => void;
  onDecline: (inviteId: string) => void;
  isAccepting: boolean;
  isDeclining: boolean;
}

/** Renders a single pending invitation with accept and decline actions. */
export function InviteEntry({ invite, onAccept, onDecline, isAccepting, isDeclining }: InviteEntryProps) {
  const { t } = useTranslation();
  const isProcessing = isAccepting || isDeclining;

  return (
    <div className="flex items-center justify-between p-4 border border-border rounded-lg bg-surface">
      <p className="text-sm text-onsurface">
        {t('userProfile.invites.invitedToJoin', { companyName: invite.companyName })}
      </p>
      <div className="flex gap-2 ml-4 shrink-0">
        <button
          type="button"
          onClick={() => onDecline(invite.id)}
          disabled={isProcessing}
          className="cursor-pointer px-1 py-2 text-sm font-medium opacity-50 hover:text-onsurface transition-colors disabled:opacity-30"
        >
          {t('userProfile.invites.decline')}
        </button>

        <button
          type="button"
          onClick={() => onAccept(invite.id)}
          disabled={isProcessing}
          className="cursor-pointer box-border px-1 py-2 text-sm font-bold opacity-80 text-primary hover:opacity-100 transition-colors disabled:opacity-30"
        >
          {t('userProfile.invites.accept')}

        </button>

        {/* <Button onClick={() => onAccept(invite.id)} disabled={isProcessing}>
          {t('userProfile.invites.accept')}
        </Button> */}
      </div>
    </div>
  );
}
